import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import { VolunteerOrgActivity } from "./entity";

const createCustomFilter =
  createCustomFilterForEntity<VolunteerOrgActivity>();

export class VolunteerOrgActivityFilters {
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<VolunteerOrgActivity>
  >((filters) => filterWithRelationsAndJson(VolunteerOrgActivity)(filters));
}
